import { Field, Formik } from "formik";
import { isEmpty, get, camelCase } from "lodash";
import React, { useState, useEffect } from "react";
import { Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  useDeepEffect,
  useRequest,
  useRouterParams,
} from "../../../../../abstracts";
import {
  DatePicker,
  FieldDropSide,
  CsplTable as Table,
  MultiSelectDropdown,
  Link,
  SliderPanel,
  AddToolTip,
} from "../../../../../components";
import {
  getPlansContributions,
  getSourceLevelContribution,
  getEmployeePlanSources,
  getEmployeeManagePlans,
} from "../../../../../services";
import {
  manageCensusFormNames,
  usDateFormat,
  formFields,
  toMultiSelectValue,
  formatDateForApiRequest,
  usCurrency,
} from "../../../../../utils";
import AddContributions from "./AddContributions";
import ContributionsSidePanel from "./ContributionsSidePanel";
import {
  setManageCensusPageLevelData,
  manageCensusStore,
} from "../../../../../contexts";
import { useContext } from "react";
import authService from "../../../../../components/api-authorization/AuthorizeService";
import permissions from "../../../../../mocks/menuPermissions.json";
const columns = [
  {
    label: "Pay date",
    className: "column-payDate",
    columnName: "payDate",
  },
  {
    label: "Total Contributions",
    className: "column-contributionAmount",
    columnName: "contributionAmount",
  },
  {
    label: "Updated Through",
    className: "column-uploadedThrough",
    columnName: "uploadedThrough",
  },
  {
    label: "Updated By",
    className: "column-updatedBy",
    columnName: "updatedBy",
  },
  {
    label: "Comments",
    className: "column-comments",
    columnName: "comments",
  },
];
const updatedThrough = ["FileUpload", "UI Editing", "CorrectionEntry", "Data Initialization"];
const updatedBy = [null, "Admin"];
var defaultStartDate = new Date();
defaultStartDate.setDate(defaultStartDate.getDate() - 120);
defaultStartDate = usDateFormat(defaultStartDate);
const defaultEndDate = usDateFormat(new Date());

const Contributions = (props) => {
  const { menu, subMenu } = props;
  const [filteredResponse, setFilteredResponse] = useState([]);
  const { state, dispatch } = useContext(manageCensusStore);
  const [showContributionsForm, setShowContributionsForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [sidePanelData, setSidePanelData] = useState({});
  const { planId, censusId } = useRouterParams();
  const [toggle, setToggle] = useState(false);
  const [sources, setSources] = useState([]);
  const [currentPlan, setCurrentPlan] = useState({});
  // const { response: sources } = useRequest({
  //   method: getEmployeePlanSources,
  //   payload: {
  //     planId: planId,
  //     companyId: get(state, "companyId", 0),
  //   },
  //   defaultResponse: [],
  // });
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  const subMenuItem =
    permissions[roleName][menu + "SubMenu"]?.[camelCase(subMenu)];
  const isAllowed = (icon, isAddButton) => {
    if (icon === "pencil-alt") {
      return (subMenuItem || "").includes("U") ? true : false;
    } else if (isAddButton) {
      return (subMenuItem || "").includes("C") &&
        (subMenuItem || "").includes("U")
        ? true
        : false;
    } else if (icon === "times") {
      return true;
    }
  };
  useDeepEffect(() => {
    getEmployeePlanSources({
      planId: parseInt(planId),
      companyId: get(state, "companyId", 0),
    })
      .then((response) => {
        setSources(response);
      })
      .catch((error) => {
        //Handle Error
      });
    getEmployeeManagePlans(censusId)
      .then((response) => {
        setCurrentPlan(response.find((_) => _.id === parseInt(planId)));
      })
      .catch((error) => {});
  }, [toggle]);

  useDeepEffect(() => {
    getPlansContributions({
      employeeId: parseInt(censusId),
      planId: parseInt(planId),
      sourceslist: sources.map((source) => source.id),
      startDate: defaultStartDate,
      endDate: defaultEndDate,
    })
      .then((response) => {
        setFilteredResponse(response);
      })
      .catch((error) => {
        //Handle Error
      });
  }, [sources, toggle]);

  const formName = manageCensusFormNames.CONTRIBUTIONS_FILTER;
  const fields = formFields[formName];

  const onFormSubmit = (values) => {
    dispatch(
      setManageCensusPageLevelData({
        formName: formName,
        fieldData: values,
      })
    );
  };

  const onFilter = (values) => {
    setIsLoading(true);
    getPlansContributions({
      sourcesList: values.sourcesList,
      employeeId: parseInt(censusId),
      planId: parseInt(planId),
      startDate: values.startDate,
      endDate: values.endDate,
    })
      .then((res) => {
        setFilteredResponse(res);
      })
      .catch((error) => {
        //Handle Errors
      });
    setIsLoading(false);
  };

  const toggleContributionsForm = () => {
    setShowContributionsForm(!showContributionsForm);
  };

  const onViewButtonClick = (data) => {
    getSourceLevelContribution({
      planId: parseInt(planId),
      employeeId: parseInt(censusId),
      payDate: data.payDate,
      comments: data.comments,
      uploadedThrough: data.uploadedThrough,
      updatedBy: 1,
      ids: data.ids,
    })
      .then((response) => {
        data = {
          ...data,
          contributions: response,
        };
        setSidePanelData(data);
        setModalOpen(true);
      })
      .catch((error) => {
        //Handle Error
      });
  };

  return (
    <>
      {!showContributionsForm && (
        <div className="w-100">
          <div className="d-flex w-100 align-items-center justify-content-between">
            <div className="plan-sub-heading">Show records of period</div>
          </div>

          <Formik
            initialValues={{
              startDate: defaultStartDate,
              endDate: defaultEndDate,
              sourcesList: sources.map((source) => source.id),
            }}
            onSubmit={onFormSubmit}
            enableReinitialize
          >
            {({
              handleChange,
              setFieldValue,
              handleSubmit,
              values,
              ...rest
            }) => {
              const onDaySelected = (fieldName, value) => {
                setFieldValue(fieldName, value);
              };
              const selectedSources = values[fields.sourcesList];
              return (
                <Form
                  autoComplete="off"
                  className="h-100"
                  onSubmit={handleSubmit}
                >
                  <div className="d-flex justify-content-between compensation-container w-100">
                    <div className="d-flex align-items-center justify-content-between w-100 ">
                      <Field
                        size="smd"
                        label="Start Date"
                        name={fields.startDate}
                        value={usDateFormat(values[fields.startDate])}
                        isDatePicker
                        onClear={() => onDaySelected(fields.startDate, null)}
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(fields.startDate, value)
                            }
                            value={usDateFormat(values[fields.payDate])}
                          />
                        }
                        component={FieldDropSide}
                      />
                      <Field
                        size="smd"
                        label="End Date"
                        name={fields.endDate}
                        value={usDateFormat(values[fields.endDate])}
                        isDatePicker
                        onClear={() => onDaySelected(fields.endDate, null)}
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(fields.endDate, value)
                            }
                            value={usDateFormat(values[fields.endDate])}
                          />
                        }
                        component={FieldDropSide}
                      />
                      <Field
                        size="sm"
                        label="Sources"
                        name={fields.sourcesList}
                        value={toMultiSelectValue(selectedSources, sources)}
                        isMultiSelect
                        popupContent={
                          <MultiSelectDropdown
                            label="Select Sources"
                            name={fields.sourcesList}
                            onSelect={(value) =>
                              setFieldValue(fields.sourcesList, value)
                            }
                            value={values[fields.sourcesList]}
                            options={
                              sources &&
                              sources.map((source, index) => ({
                                label: source.name,
                                value: source.id,
                              }))
                            }
                          />
                        }
                        component={FieldDropSide}
                      />
                      <Button
                        onClick={() => onFilter(values)}
                        type="button"
                        className="align-center"
                      >
                        Go
                      </Button>
                      <div className="mr-4 mt-12">
                        {filteredResponse.length} records
                      </div>
                    </div>
                    <div className="align-center">
                      {isAllowed("", true) ? (
                        <Button
                          type="button"
                          className="add-btn"
                          onClick={toggleContributionsForm}
                          variant="secondary"
                          disabled={currentPlan.status != "Eligible"}
                        >
                          Add Contributions
                        </Button>
                      ) : null}
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
          <br />
          <Table isLoading={isLoading} className="contributions-table">
            <Table.Thead>
              <Table.Tr>
                {columns.map((item, index) => {
                  return (
                    <Table.Th key={index} className={item.className}>
                      {item.label}
                    </Table.Th>
                  );
                })}
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {filteredResponse.map((contributions, index) => {
                return (
                  <Table.Tr key={index}>
                    {columns.map((item, cellIndex) => {
                      const getContent = () => {
                        if (item.columnName === "contributionAmount") {
                          return (
                            <Link
                              onClick={() =>
                                onViewButtonClick({
                                  payDate: contributions.payDate,
                                  totalContribution: usCurrency(
                                    contributions.contributionAmount
                                  ),
                                  comments: contributions.comments,
                                  updatedBy: contributions.updatedBy,
                                  uploadedThrough:
                                    contributions.uploadedThrough,
                                  ids: contributions.ids,
                                })
                              }
                            >
                              {usCurrency(contributions[item.columnName])}
                            </Link>
                          );
                        }

                        if (item.columnName === "payDate") {
                          return usDateFormat(contributions[item.columnName]);
                        }
                        if (item.columnName === "uploadedThrough") {
                          return updatedThrough[
                            contributions[item.columnName] - 1
                          ];
                        }
                        if (
                          item.columnName === "updatedBy" ||
                          item.columnName === "comments"
                        ) {
                          return (
                            <AddToolTip
                              name={contributions[item.columnName] || "-"}
                              placement="top"
                            >
                              {contributions[item.columnName] || "-"}
                            </AddToolTip>
                          );
                        }
                        if (item.dataMapper) {
                          return item.dataMapper[
                            contributions[item.columnName]
                          ];
                        }
                        return contributions[item.columnName];
                      };
                      return (
                        <Table.Td key={cellIndex} className={item.className}>
                          {getContent()}
                        </Table.Td>
                      );
                    })}
                  </Table.Tr>
                );
              })}
            </Table.Tbody>
          </Table>
        </div>
      )}
      {/* {showContributionsForm && (
        <AddContributions
          toggleContributionsForm={toggleContributionsForm}
          sources={sources}
          setToggle={setToggle}
          toggle={toggle}
          {...props}
        />
      )} */}
      <SliderPanel
        isOpen={showContributionsForm}
        size="40"
        showCancel={false}
        onClose={() => setModalOpen(false)}
      >
        <AddContributions
          toggleContributionsForm={toggleContributionsForm}
          sources={sources}
          setToggle={setToggle}
          toggle={toggle}
          {...props}
        />
      </SliderPanel>

      <SliderPanel
        isOpen={isModalOpen}
        size="40"
        onClose={() => setModalOpen(false)}
      >
        <ContributionsSidePanel data={sidePanelData} />
      </SliderPanel>
    </>
  );
};

export default Contributions;
